<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) { @if(canManageDrafts){
  <div class="buttons mb-2">
    <button buttonTheme="light" buttonType="regular" buttonSize="sm" (click)="displayCustomerCreate('doctor')">
      <ng-icon name="shoppingBagPocket" size="20"></ng-icon>
      {{ dictionaryService.get('addDoctor') }}
    </button>
    <button buttonTheme="light" buttonType="regular" buttonSize="sm" (click)="displayCustomerCreate('provider')">
      <ng-icon name="shoppingBagPocket" size="20"></ng-icon>
      {{ dictionaryService.get('addProvider') }}
    </button>
    <button buttonTheme="light" buttonType="regular" buttonSize="sm" (click)="displayCustomerCreate('pharmacy')">
      <ng-icon name="shoppingBagPlus" size="20"></ng-icon>
      {{ dictionaryService.get('addPharmacy') }}
    </button>
    <button buttonTheme="light" buttonType="regular" buttonSize="sm" (click)="displayCustomerCreate('hospital')">
      <ng-icon name="hospital" size="20"></ng-icon>
      {{ dictionaryService.get('addHospital') }}
    </button>
  </div>
  }
  <app-draft-routes />
  }
</app-tab-layout>

<!-- Customer Create Modal -->
<app-customer-create-modal [isOpen]="isCreateModalOpen()" [customerType]="selectedCustomerType()"
  (onClose)="handleCreateModalClose()" (onSubmitApi)="handleCreateCustomerApi($event)"></app-customer-create-modal>
